// Copyright 2023 Sorama B.V.
export type CAMName = "CAM64" | "CAM1K" | "CAMiV64" | "CAMiV64Ex" | "CAMiV64s" | "L642" | "L642Ex" | "L642V+";

export abstract class IWorkflowMode {
    public abstract readonly name: string;

    public abstract readonly CAMSet: Set<CAMName>;
    public abstract readonly CAMSetName: string;

    // Portal features related to reporting. Determines whether Feature/License store, Management tab (only cloud and external recs) and Special Measurements are available
    public abstract readonly canDoReporting: boolean;

    // Portal features related to CAM64 & CAM1K. Determines whether Streaming and Measurement tab are available
    public abstract readonly canDoRealTimeRecording: boolean;

    // Determines whether Analysis, Presentation, and Offline file management tab are available
    // Also determines whether timeline and journal features are available
    public abstract readonly canDoMeasurementAnalysis: boolean;

    // Determines whether the user can use the EX features of portal
    public abstract readonly isIndustrial: boolean;

    // Determines whether the user can use the Building features of portal
    public abstract readonly isBuilding: boolean;

    public get isIndustrialFixed() {
        return this.isIndustrial && this.canUseL642;
    }

    public get canUseHandheld() {
        return this.CAMSet.has("CAMiV64") || this.CAMSet.has("CAMiV64Ex") || this.CAMSet.has("CAMiV64s");
    }
    public get canUseCAM64AndCAM1K() {
        return this.CAMSet.has("CAM64") || this.CAMSet.has("CAM1K");
    }
    public get canUseL642() {
        return this.CAMSet.has("L642") || this.CAMSet.has("L642Ex") || this.CAMSet.has("L642V+");
    }

    public get canConnectDevice() {
        return this.canUseHandheld || this.canUseCAM64AndCAM1K;
    }

    public shouldShowWorkflow(workflowName: string): boolean {
        switch (workflowName.toLowerCase()) {
            case "streamer":
                return this.canDoRealTimeRecording;
            case "measurement":
                return this.canDoRealTimeRecording;
            case "analysis":
                return this.canDoMeasurementAnalysis && !this.isIndustrial;
            case "report":
                return this.canDoReporting && !this.isIndustrial;
            case "reporting":
                return this.canDoReporting && this.isIndustrial;
            case "recordings":
                return this.canDoMeasurementAnalysis && !this.isIndustrial;
            case "presentations":
                return this.canDoMeasurementAnalysis && !this.isIndustrial;
        }
        return true;
    }
}
